import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_WARRANTY_TASK_CODES = {
  'list': [],
  'loading': false,
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'values': {
    'code': '',
    'description': '',
    'status': 'A',
  },
};

export const warrantyTasksCodes = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTY_TASK_CODES, {
    [ActionTypes.FETCHING_WARRANTY_TASK_CODES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WARRANTY_TASK_CODES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_WARRANTY_TASK_CODES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_WARRANTY_TASK_CODES_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_WARRANTY_TASK_CODES,
    }),
  })(state, action);
};

export const tasksCodesForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHED_WARRANTY_TASK_CODE]: (state, action) => ({
      ...state,
      'loading': true,
      'values': {
        ...state.values,
        'code': action.response.data.id,
        'description': action.response.data.description,
        'status': action.response.data.status,
      },
    }),
    [ActionTypes.FETCHED_WARRANTY_TASK_CODE_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'code': '',
        'description': '',
        'status': '',
      },
    }),
    [ActionTypes.CLEAN_WARRANTY_TASK_CODE]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'code': '',
        'description': '',
        'status': 'A',
      },
    }),
  })(state, action);
};
